import User1 from "@/assets/images/users/user-1.jpg";
import Icon from "@/components/wrappers/Icon";
import { getStoredUser, useAuth } from "@/context/AuthContext"; // import your clear function
import { Fragment } from "react";
import {
  Dropdown,
  DropdownDivider,
  DropdownHeader,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "react-bootstrap";

type MenuItem = {
  id: string;
  label: string;
  icon: string;
  link: string;
  divider?: boolean;
  isSemibold?: boolean;
};

const menuItems: MenuItem[] = [
  // {
  //   id: "profile",
  //   label: "Profile",
  //   icon: "user-circle",
  //   link: "/profile",
  // },
  {
    id: "settings",
    label: "Account Settings",
    icon: "settings",
    link: "/profile",
  },
  {
    id: "notifications",
    label: "Notifications",
    icon: "bell-ringing",
    link: "/profile?tab=notification",
    divider: true,
  },
  // {
  //   id: "settings",
  //   label: "Account Settings",
  //   icon: "settings-2",
  //   link: "",
  // },
  // {
  //   id: "support",
  //   label: "Support Center",
  //   icon: "headset",
  //   link: "",
  //   divider: true,
  // },
  // {
  //   id: "lock",
  //   label: "Lock Screen",
  //   icon: "lock",
  //   link: "/auth/lock-screen",
  // },
  {
    id: "logout",
    label: "Log Out",
    icon: "logout",
    link: "",
    isSemibold: true,
  },
];

const UserDropdown = () => {
  const user = getStoredUser();

  const { logout } = useAuth();

  const handleLogout = () => {
    // Clear storage
    logout(); // Call the logout function from the context
  };

  return (
    <div id="user-dropdown-detailed" className="topbar-item nav-user">
      <Dropdown>
        <DropdownToggle
          className="topbar-link drop-arrow-none text-start"
          as="button"
        >
          <div className="d-lg-flex align-items-center gap-1 d-none">
            <span>
              <h5 className="my-0 lh-1 pro-username">{user?.name}</h5>
              <span className="fs-xs lh-1">{user?.email}</span>
            </span>
            <Icon icon="chevron-down" className="align-middle" />
          </div>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-end">
          <DropdownHeader className="noti-title">
            <h6 className="text-overflow m-0">Welcome back 👋!</h6>
          </DropdownHeader>

          {menuItems.map((item) => (
            <Fragment key={item.id}>
              <DropdownItem
                href={item.id !== "logout" ? item.link : undefined}
                onClick={
                  item.id === "logout"
                    ? (e) => {
                        e.preventDefault();
                        handleLogout();
                      }
                    : undefined
                }
                className={item.isSemibold ? "fw-semibold" : ""}
              >
                <Icon icon={item.icon} className="me-1 fs-lg align-middle" />
                <span className="align-middle">{item.label}</span>
              </DropdownItem>

              {item.divider && <DropdownDivider />}
            </Fragment>
          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default UserDropdown;
